import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'

import Modal from '../../common/Modal'
import Input from '../../common/form/Input'
import mobilePairings from '../../../assets/images/mock/mobile-pairings.webp'

import classes from './PublishPairingsModal.module.scss'
import { ReactComponent as GolferIcon } from '../../../assets/images/common/icons/golfer-half-icon.svg'

const DESCRIPTION_MAX_LENGTH = 400

const PublishPairingsModal = ({ showModal, closeModal, submitButton, secondButton, extraContent, emailMessage, handleMessageChange }) => {
  const { t } = useTranslation()

  return (
    <Modal
      isOpen={showModal}
      onClose={closeModal}
      contentLabel={t('events.modal.publishPairings.contentLabel')}
      className={classes['modal']}
      autoFocus
    >
      <div className={classes['wrapper']}>
        <div className='d-flex align-items-end'>
          <div className={classes['text-content']}>
            <div className={classnames('d-flex align-items-center', classes['title-container'])}>
              <div className={classnames('d-flex justify-content-center align-items-center', classes['icon-wrapper'])}>
                <GolferIcon className={classes['golfer-icon']} fill='#fff' width={'30px'} height={'30px'} />
              </div>
              <span className={classes['title']}>{t('events.common.publishPairings')}</span>
            </div>
            <div className={classes['text-container']}>{t('events.modal.publishPairings.confirmation')}</div>
            <div className={classnames('mt-3', classes['text-container'])}>{extraContent}</div>
          </div>
          <div className={classnames('d-flex justify-content-end', classes['image'])}>
            <img className={classes['mobile-leaderboard']} src={mobilePairings} alt={t('events.modal.publishPairings.leaderboardAlt')} />
          </div>
        </div>
        <div className='mt-3'>
          <span className={classes.secondaryText}>{t('events.modal.publishPairings.customMessageLabel')}</span>
          <div className='mt-3'>
            <Input
              name='emailMessage'
              type='textarea'
              onChange={handleMessageChange}
              placeholder={t('events.modal.publishPairings.messagePlaceholder')}
              value={emailMessage}
              maxLength={DESCRIPTION_MAX_LENGTH}
              styles={{ inputContainer: { height: '150px' } }}
            />
            <p className={classes.characterCounter}>
              {t('events.modal.publishPairings.characterCounter', { length: emailMessage?.length, max: DESCRIPTION_MAX_LENGTH })}
            </p>
          </div>
        </div>
        {submitButton}
        {secondButton}
      </div>
    </Modal>
  )
}

PublishPairingsModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  submitButton: PropTypes.object,
  secondButton: PropTypes.object,
  extraContent: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  emailMessage: PropTypes.string,
  handleMessageChange: PropTypes.func,
}

export default PublishPairingsModal
